import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type SessionStore = {
  isAdmin: boolean;
  isAuthComplete: boolean;
  setIsAuthComplete: (isAuthComplete: boolean) => void;
  setIsAdmin: (isAdmin: boolean) => void;
  setAccessToken: (accessToken: string | null) => void;
  logout: () => void;
};

type PersistedStore = {
  accessToken: string | null;
};

type AuthStore = SessionStore & PersistedStore;

const useAuthStore = create<AuthStore, [['zustand/persist', PersistedStore]]>(
  persist(
    (set) => ({
      accessToken: null,
      isAdmin: false,
      isAuthComplete: false,
      setIsAuthComplete: (isAuthComplete) => set({ isAuthComplete }),
      setIsAdmin: (isAdmin) => set({ isAdmin }),
      setAccessToken: (accessToken) => set({ accessToken }),
      logout: () => set({ accessToken: null, isAdmin: false }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ accessToken: state.accessToken }),
    },
  ),
);

export { useAuthStore };
